// extracted by mini-css-extract-plugin
export default {"base":"odN2X","tipHeader":"WtXDO","column":"ie6kL","highlightBox":"BK9d5"};